export const getSurplusBeforeTaxYear3 = (value) => {
  return {
    type: "GET_SURPLUS_BEFORE_TAX_YEAR_3",
    payload: value,
  };
};

export const getTemplatePayrollTaxYear3 = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_TAX_YEAR_3",
    payload: value,
  };
};
export const getTemplatePayrollPercentYear3 = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getFixedEarnedIncomeYear3 = (value) => {
  return {
    type: "GET_FIXED_EARNED_INCOME_YEAR_3",
    payload: value,
  };
};

export const getStandardTaxReliefYear3 = (value) => {
  return {
    type: "GET_STANDARD_TAX_RELIEF_YEAR_3",
    payload: value,
  };
};
export const getTaxableIncomeYear3 = (value) => {
  return {
    type: "GET_TAXABLE_INCOME_YEAR_3",
    payload: value,
  };
};
export const getLocalTaxesYear3 = (value) => {
  return {
    type: "GET_LOCAL_TAXES_YEAR_3",
    payload: value,
  };
};
export const getLocalTaxesPercentYear3 = (value) => {
  return {
    type: "GET_LOCAL_TAXES_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getStateTaxYear3 = (value) => {
  return {
    type: "GET_STATE_TAX_YEAR_3",
    payload: value,
  };
};
export const getStateTaxCutOfValueYear3 = (value) => {
  return {
    type: "GET_STATE_TAX_CUT_OF_VALUE_YEAR_3",
    payload: value,
  };
};
export const getStateTaxPercentYear3 = (value) => {
  return {
    type: "GET_STATE_TAX_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getPayrollTaxYear3 = (value) => {
  return {
    type: "GET_PAYROLL_TAX_YEAR_3",
    payload: value,
  };
};
export const getPayrollTaxPercentYear3 = (value) => {
  return {
    type: "GET_PAYROLL_TAX_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getGeneralPensionYear3 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_YEAR_3",
    payload: value,
  };
};
export const getGeneralPensionCutOffValueYear3 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_CUT_OFF_VALUE_YEAR_3",
    payload: value,
  };
};
export const getGeneralPensionPercentYear3 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getFuneralFeesYear3 = (value) => {
  return {
    type: "GET_FUNERAL_FEES_YEAR_3",
    payload: value,
  };
};
export const getFuneralFeesPercentYear3 = (value) => {
  return {
    type: "GET_FUNERAL_FEES_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getReductionOfGeneralPensionYear3 = (value) => {
  return {
    type: "GET_REDUCTION_OF_GENERAL_PENSION_YEAR_3",
    payload: value,
  };
};
export const getEarnedIncomeTaxYear3 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_YEAR_3",
    payload: value,
  };
};
export const getEarnedIncomeTaxCutOffValueYear3 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_CUT_OFF_VALUE_YEAR_3",
    payload: value,
  };
};
export const getEarnedIncomeTaxPercentYear3 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getNetProfitPerYearYear3 = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_YEAR_YEAR_3",
    payload: value,
  };
};
export const getNetProfitPerMonthYear3 = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_MONTH_YEAR_3",
    payload: value,
  };
};
export const getGeneralPayrollTaxYear3 = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_YEAR_3",
    payload: value,
  };
};
export const getGeneralPayrollTaxPercentYear3 = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_PERCENT_YEAR_3",
    payload: value,
  };
};
export const getGrossAnnualSalaryYear3 = (value) => {
  return {
    type: "GET_GROSS_ANNUAL_SALARY_YEAR_3",
    payload: value,
  };
};
export const getNonTaxableIncomeLimitYear3 = (value) => {
  return {
    type: "GET_NON_TAXABLE_INCOME_LIMIT_YEAR_3",
    payload: value,
  };
};
